import React from 'react';
import { iconType } from 'src/types';

const ExportIcon: React.FC<iconType.PropsType> = ({ className, onClick, style, color }) => {
  return (
    <div
      className={className && className}
      role="button"
      onClick={onClick && onClick}
      onKeyDown={onClick && onClick}
      tabIndex={onClick && -1}
      style={onClick ? { cursor: 'pointer', display: 'flex' } : { display: 'flex' }}
    >
      <svg
        style={{ ...style }}
        data-name="Layer 1"
        id="Layer_1"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        height="27px"
        width="32px"
        fill={color || 'var(--primary_text_color)'}
      >
        <path d="M421.24,269.93h30V429.84a48.72,48.72,0,0,1-48.66,48.66H82.77a48.72,48.72,0,0,1-48.66-48.66V110A48.72,48.72,0,0,1,82.77,61.37H242.68v30H82.77A18.68,18.68,0,0,0,64.11,110V429.84A18.68,18.68,0,0,0,82.77,448.5H402.58a18.68,18.68,0,0,0,18.66-18.66Zm-69-236.43v30h74.4L249.5,240.68l21.21,21.21L447.89,84.71v74.4h30V33.5Z" />
      </svg>
    </div>
  );
};

export default ExportIcon;
